import React, { Component } from "react";
import Select from "react-select";
import Capsule from "../../common/components/Capsule";
import TimeField from "react-simple-timefield";
import produce from "immer";
import { changeCursorPosition, handleDisplayTime } from "../../lib/helper";
import withTranslation from "../../i18n/withTranslation";

class WizytaHotelowa extends Component {
   constructor(props) {
      super(props);
      this.state = {
         displayTimeField: false,
         timeFieldDataType: ""
      };
   }

   handleTaskSelect = (selectedTask) => {
      const { handleChange, data } = this.props;
      const nextData = produce(data, (draft) => {
         draft.typ = selectedTask.value;
      });
      handleChange(nextData, true);
   };

   addUser = (user) => {
      const { handleChange, data } = this.props;
      const nextData = produce(data, (draft) => {
         draft.uzytkownicy.push(user);
      });
      handleChange(nextData);
   };

   removeAssignedUser = (id) => {
      const { handleChange, data } = this.props;
      const nextData = produce(data, (draft) => {
         draft.uzytkownicy = draft.uzytkownicy.filter((user) => user.id !== id);
      });
      handleChange(nextData);
   };

   availableUsers = () => {
      const { data, allUsers } = this.props;
      const userIds = data.uzytkownicy.map((user) => user.id);
      return allUsers.filter((user) => !userIds.includes(user.id));
   };

   handleInput = (ev) => {
      const { handleChange, data } = this.props;
      const nextData = produce(data, (draft) => {
         draft.dane[ev.target.id] = ev.target.value;
      });
      handleChange(nextData);
   };

   availableHotels = () => {
      const { data, hotels } = this.props;
      const hotelIds = data.dane.hotele.map((hotel) => hotel.id);
      return hotels.filter((hotel) => !hotelIds.includes(hotel.value));
   };

   addHotel = (hotel) => {
      const { handleChange, data } = this.props;
      const nextData = produce(data, (draft) => {
         draft.dane.hotele.push({ id: hotel.value, nazwa: hotel.label });
         if (hotel.miejsceSpotkania) draft.dane.miejsce = hotel.miejsceSpotkania;
      });
      handleChange(nextData);
   };

   removeAssignedHotel = (id) => {
      const { handleChange, data } = this.props;
      const nextData = produce(data, (draft) => {
         draft.dane.hotele = draft.dane.hotele.filter((hotel) => hotel.id !== id);
      });
      handleChange(nextData);
   };

   handleHourChange = (event, value) => {
      const { handleChange, data } = this.props;
      const { timeFieldDataType } = this.state;
      const nextData = produce(data, (draft) => {
         draft.dane[timeFieldDataType] = value;
      });
      handleChange(nextData);
   };

   handleDisplayTimeField = (e, dataType) =>
      handleDisplayTime(e, this.setState.bind(this), dataType);

   render() {
      const { data, allTasks, handleDestroy } = this.props;
      const { displayTimeField, timeFieldDataType } = this.state;
      
      return (
         <form
            id={`form-${data.id}`}
            className="form margin--top form-child"
            style={{ marginBottom: 20 }}
         >
            <span onClick={() => handleDestroy(data.id)} className="icon icon-close_icon"></span>
            <Select
               value={allTasks.find((option) => option.value === data.typ)}
               options={allTasks}
               placeholder={this.props.t("taskForms.selectTask")}
               onChange={this.handleTaskSelect}
               isClearable={false}
            />
            <div className="margin--top row">
               <div className="col-12">
                  <input
                     value={data.dane.miejsce}
                     placeholder={this.props.t("taskForms.meetingPlace")}
                     className="select-input"
                     id="miejsce"
                     onChange={this.handleInput}
                  />
               </div>
            </div>
            <div className="margin--top row">
               <div className="col-6">
                  {displayTimeField && timeFieldDataType === "godzOd" ? (
                     <TimeField
                        className="hour-input"
                        value={data.dane.godzOd}
                        onChange={this.handleHourChange}
                        onClick={changeCursorPosition}
                        id="wizyta-hotelowa-godzOd"
                        autoFocus
                     />
                  ) : (
                     <input
                        className="hour-input"
                        autoComplete="off"
                        readOnly
                        id="godzOd"
                        name="wizyta-hotelowa-godzOd"
                        placeholder={this.props.t("taskForms.timeFrom")}
                        value={data.dane.godzOd}
                        type="text"
                        onClick={(e) => this.handleDisplayTimeField(e, "godzOd")}
                        onFocus={(e) => this.handleDisplayTimeField(e, "godzOd")}
                     />
                  )}
               </div>
               <div className="col-6">
                  {displayTimeField && timeFieldDataType === "godzDo" ? (
                     <TimeField
                        className="hour-input"
                        value={data.dane.godzDo || "00:00"}
                        onChange={this.handleHourChange}
                        onClick={changeCursorPosition}
                        id="wizyta-hotelowa-godzDo"
                        autoFocus
                     />
                  ) : (
                     <input
                        className="hour-input"
                        autoComplete="off"
                        readOnly
                        id="godzDo"
                        name="wizyta-hotelowa-godzDo"
                        placeholder={this.props.t("taskForms.timeTo")}
                        value={data.dane.godzDo}
                        type="text"
                        onClick={(e) => this.handleDisplayTimeField(e, "godzDo")}
                        onFocus={(e) => this.handleDisplayTimeField(e, "godzDo")}
                     />
                  )}
               </div>
            </div>
            <div className="margin--top flex flex--align-center flex--wrap-wrap">
               <span className="margin--bottom">{this.props.t("taskForms.selectedHotels")}</span>
               {data.dane.hotele.map((hotel) => (
                  <Capsule
                     key={hotel.id}
                     className="margin--left margin--bottom"
                     id={hotel.id}
                     text={hotel.nazwa}
                     onRemove={this.removeAssignedHotel}
                  />
               ))}
               <Select
                  options={this.availableHotels()}
                  value={null}
                  className="margin--left margin--bottom col-4 padding--remove"
                  placeholder={this.props.t("taskForms.addHotel")}
                  onChange={this.addHotel}
               />
            </div>
            <div className="margin--top flex flex--align-center flex--wrap-wrap">
               <span className="margin--bottom">{this.props.t("taskForms.assigned")}</span>
               {data.uzytkownicy.map((user) => (
                  <Capsule
                     key={user.id}
                     className="margin--left margin--bottom"
                     id={user.id}
                     text={user.imieNazwisko}
                     onRemove={this.removeAssignedUser}
                  />
               ))}
               <Select
                  options={this.availableUsers()}
                  value={null}
                  className="margin--left margin--bottom col-4 padding--remove"
                  placeholder={this.props.t("taskForms.addPerson")}
                  onChange={this.addUser}
               />
            </div>
            <div>
               <textarea
                  id="uwagi"
                  rows={5}
                  value={data.dane.uwagi}
                  placeholder={this.props.t("taskForms.notes")}
                  onChange={this.handleInput}
               />
            </div>
         </form>
      );
   }
}

export default withTranslation(WizytaHotelowa);
